import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPrice } from '../../utils/helpers';

const ARRIVAL = 'Arrival';
const DEPARTURE = 'Departure';

const InfoForm = ({ isAdult, type, data, transportOptions, onChange }) => {
  var unacompanniedPrice = window.unaccompagnnied.price;
  if(data && data.unacompanniedinternational){
    unacompanniedPrice = window.unaccompagnnied_international.price;
  }
  return (
    <div className="info-form">
      <h4 className="field__title">{type} Info</h4>

      <label
        className={classNames('field__label', 'select', {
          'field__input--selected': data && !!data.airport,
        })}
      >
        <select
          // Used to force render this select when options change
          // defaultValue will not be effective
          key={transportOptions.length}
          defaultValue={(data && data.airport) || ''}
          className="field__select"
          onChange={(e) =>
            onChange({
              airport: e.target.value ? Number(e.target.value) : null,
            })
          }
        >
          <option value="">{type} Airport</option>
          {transportOptions.map((o) => (
            <option
              key={o.id}
              value={o.id}
              className={classNames('field__option', {
                'field__option--selected': data ? data.airport === o.id : false,
              })}
            >
              {o.airport} - {formatPrice(o.price)}
            </option>
          ))}
        </select>
      </label>

      {!isAdult && (
        <div className="info-form__minor">
          <div className="info-form__minor-heading">
            <h5>Is your flight international?</h5>
          </div>
          <label
            className={classNames('field__label', {
              'field__input--selected': data && data.unacompanniedinternational,
            })}
          >
            Yes
            <input
              type="checkbox"
              className={classNames('field__input', {
                'field__input--selected': data && data.unacompanniedinternational,
              })}
              defaultChecked={data && data.unacompanniedinternational === true}
              name={`${type}-unaccompaniedinternational`}
              onChange={() => onChange({ unacompanniedinternational: true })}
            />
          </label>
          <label
            className={classNames('field__label', {
              'field__input--selected': data && data.unacompanniedinternational === false,
            })}
          >
            No
            <input
              type="checkbox"
              className={classNames('field__input', {
                'field__input--selected': data && data.unacompanniedinternational === false,
              })}
              defaultChecked={data && data.unacompanniedinternational === false}
              name={`${type}-unaccompaniedinternational`}
              onChange={() => onChange({ unacompanniedinternational: false })}
            />
          </label>
          <div className="info-form__minor-heading">
            <h5>Unaccompanied minor?</h5>
            <div
              className="info"
              onClick={() => {
                if (typeof window.reactOpenPopup === 'function') {
                  window.reactOpenPopup('minor');
                }
              }}
            ></div>
          </div>
          <label
            className={classNames('field__label', {
              'field__input--selected': data && data.unacompannied,
            })}
          >
            Yes + ${Math.round(unacompanniedPrice)}
            <input
              type="radio"
              className={classNames('field__input', {
                'field__input--selected': data && data.unacompannied,
              })}
              defaultChecked={data && data.unacompannied === true}
              name={`${type}-unaccompanied`}
              onChange={() => onChange({ unacompannied: true })}
            />
          </label>
          <label
            className={classNames('field__label', {
              'field__input--selected': data && data.unacompannied === false,
            })}
          >
            No + $0
            <input
              type="radio"
              className={classNames('field__input', {
                'field__input--selected': data && data.unacompannied === false,
              })}
              defaultChecked={data && data.unacompannied === false}
              name={`${type}-unaccompanied`}
              onChange={() => onChange({ unacompannied: false })}
            />
          </label>
        </div>
      )}
    </div>
  );
};

InfoForm.propTypes = {
  isAdult: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([ARRIVAL, DEPARTURE]).isRequired,
  data: PropTypes.object,
  transportOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InfoForm;
